<template>
  <content-area :items="items" />
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'
export default {
  components: {
    ContentArea
  },
  computed: {
    info () {
      return this.$store.getters['hsm/GET_INFO']
    },
    bind_interface: function () {
      const nic = this.info.bound_eth
      let ans = ''

      if (
        this.info &&
        this.info.interfaces &&
        this.info.interfaces.length > 0
      ) {
        if (nic === 0) {
          const nic1 = this.info.interfaces.filter(item => item.name === 'nic1')
          const nic2 = this.info.interfaces.filter(item => item.name === 'nic2')
          if (nic1 && nic1.length > 0) ans += `<div>[1] - ${nic1[0].ip}</div>`
          if (nic2 && nic2.length > 0) ans += `<div>[2] - ${nic2[0].ip}</div>`
        } else {
          ans = `<div>[${nic}] - ${
            this.info.interfaces.filter(item => item.name === 'nic' + nic)[0].ip
          }</div>`
        }
      }
      return ans
    },
    items () {
      const info = this.info

      if (info) {
        return [
          {
            title: this.$tc('domain'),
            data: info.repl_domain ? info.repl_domain : this.$tc('none', 2),
            testId: 'domain'
          },
          {
            title: this.$tc('sync_point'),
            data: `${info.sync_point} ${info.SPVV}`,
            testId: 'sync_point'
          },
          {
            title: this.$tc('interface_bind'),
            data: this.bind_interface,
            html: true,
            testId: 'interface_bind'
          },
          {
            title: this.$tc('policy'),
            data: `
            <div>
              ${this.$tc('manager_pulsing')} - ${info.manager_pulse} ${this.$tc('seconds')}
              <br>
              ${this.$tc('recovery_pulsing')} - ${info.recovery_pulse} ${this.$tc('seconds')}
            </div>`,
            html: true,
            testId: 'policy'
          },
          {
            title: this.$tc('node_list'),
            data: info.nodes,
            testId: 'node_list'
          },
          {
            title: `${this.$tc('pending_transaction')} Peers`,
            data: info.peers,
            testId: 'pending_transaction_Peers'
          },
          {
            title: `${this.$tc('pending_transaction')} Acks`,
            data: info.pending_acks,
            testId: 'pending_transaction_Acks'
          }
        ]
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
